import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import types from './types';

const actions = {
  async getTemplates({ commit }, category = null) {
    try {
      commit(types.GET_TEMPLATES_START);
      const params = category && category !== 'all' ? { category } : {};
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.albums,
        params,
        isToken: true,
      });
      commit(types.GET_TEMPLATES_SUCCESS, data);
      return data;
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_TEMPLATES_FAILURE, message);
      throw e;
    }
  },

  async getTemplateById({ commit }, id) {
    try {
      commit(types.GET_TEMPLATE_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.albums}/${id}`,
        isToken: true,
      });
      commit(types.GET_TEMPLATE_SUCCESS, data);
      return data;
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_TEMPLATE_FAILURE, message);
      throw e;
    }
  },

  async createTemplate({ commit }, templateData) {
    try {
      commit(types.CREATE_TEMPLATE_START);
      const { data: { data } } = await apiCall({
        type: 'POST',
        url: URLS.albums,
        body: templateData,
        isToken: true,
      });
      commit(types.CREATE_TEMPLATE_SUCCESS, data);
      notificationWithIcon('success', 'Template created successfully');
      return data;
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message || 'Failed to create template');
      commit(types.CREATE_TEMPLATE_FAILURE, message);
      throw e;
    }
  },

  async updateTemplate({ commit }, { id, templateData }) {
    try {
      commit(types.UPDATE_TEMPLATE_START);
      const { data: { data } } = await apiCall({
        type: 'PUT',
        url: `${URLS.albums}/${id}`,
        body: templateData,
        isToken: true,
      });
      commit(types.UPDATE_TEMPLATE_SUCCESS, data);
      notificationWithIcon('success', 'Template updated successfully');
      return data;
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message || 'Failed to update template');
      commit(types.UPDATE_TEMPLATE_FAILURE, message);
      throw e;
    }
  },

  async deleteTemplate({ commit }, id) {
    try {
      commit(types.DELETE_TEMPLATE_START);
      await apiCall({
        type: 'DELETE',
        url: `${URLS.albums}/${id}`,
        isToken: true,
      });
      commit(types.DELETE_TEMPLATE_SUCCESS, id);
      notificationWithIcon('success', 'Template deleted successfully');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message || 'Failed to delete template');
      commit(types.DELETE_TEMPLATE_FAILURE, message);
      throw e;
    }
  },

  clearError({ commit }) {
    commit(types.CLEAR_ERROR);
  },
};

export default actions;
